import { esc, openModal, closeModal, onModalClose } from '../ui/modal';
import { t } from '../ui/lang';
import { can } from '../core/access';
const REFRESH_MS = 5000;
/**
 * The poller log of a Mercado API account, as the mercado-runner keeps it in memory. Re-read
 * every few seconds while open; a runner restart starts it over.
 */
export function showMercadoLogModal(farmId, udid, name) {
    if (!can('device.clickerLog'))
        return;
    const modal = openModal(`
        <h2 class="modal__title">${t('clicker.logs_title', { udid: esc(name) })}</h2>
        <pre class="shell-output clicker-log-output">${t('common.loading')}</pre>
    `);
    modal.classList.add('modal--clicker-log');
    const outputEl = modal.querySelector('.clicker-log-output');
    const load = async () => {
        try {
            const r = await fetch(`/api/farms/${farmId}/mercado-devices/${encodeURIComponent(udid)}/log`);
            if (!r.ok) {
                outputEl.textContent = t('farmdev.adspower_log_failed', { status: r.status });
                return;
            }
            const body = await r.json();
            const text = body.log || t('farmdev.mercado_log_empty');
            if (text === outputEl.textContent)
                return;
            // Follow the tail only when the reader is already at the bottom.
            const atBottom = outputEl.scrollTop + outputEl.clientHeight >= outputEl.scrollHeight - 4;
            outputEl.textContent = text;
            if (atBottom)
                outputEl.scrollTop = outputEl.scrollHeight;
        }
        catch {
            outputEl.textContent = t('farmdev.network_error');
        }
    };
    void load();
    const timer = window.setInterval(() => {
        if (!document.body.contains(modal)) {
            window.clearInterval(timer);
            return;
        }
        void load();
    }, REFRESH_MS);
    onModalClose(modal, () => { window.clearInterval(timer); closeModal(); });
}
